import get from 'lodash/get';

import { DataServiceModule } from 'services/data/data.service';
import { SubscriptionServiceModule } from 'services/access/subscription/subscription.service';
import { AppSettingsModule } from 'services/settings.provider';

export const FeaturesServiceModule = angular
    .module('app.services.access.featuresService', [
        DataServiceModule,
        SubscriptionServiceModule,
        AppSettingsModule
    ]).service('featureService', (dataService, settings, $q, subscriptionsService) => {
        let features;

        return {
            getFeatures,
            enableFeature,
            getInstalledApps,
            disableFeature
        };

        function getFeatures(refetch) {
            if (!features || refetch) {
                return dataService.getAll(settings.api.features).then((response) => {
                    features = response;
                    return features;
                });
            }
            return $q.resolve(features);
        }

        function canEnableFeature(feature) {
            return subscriptionsService.getSubscription().then((subscription) => {
                return subscription && subscription.features && (subscription.features[feature] === true ||
                    subscription.features[feature] === undefined);
            });
        }

        function enableFeature(featureName) {
            if (features && features[featureName]) {
                let feature = features[featureName];
                return canEnableFeature(featureName).then((featureCanBeEnabled) => {
                    if (featureCanBeEnabled) {
                        feature.enabled = true;
                        return dataService.saveAll(settings.api.features, features)
                            .then((response) => {
                                angular.extend(features, response);
                                return features;
                            }).catch(() => {
                                feature.enabled = false;
                                return $q.reject('APPSTORE.APPINSTALLERROR');
                            });
                    }
                    return $q.reject('APPSTORE.APPINSTALLERROR');
                });
            }
            return $q.resolve(features);
        }

        function disableFeature(featureName) {
            if (features && features[featureName]) {
                let feature = features[featureName];
                feature.enabled = false;
                return dataService.saveAll(settings.api.features, features)
                    .then((response) => {
                        angular.extend(features, response);
                        return features;
                    });
            }
            return $q.resolve(features);
        }

        function getInstalledApps() {
            return getFeatures().then((merchantFeatures) => {
                return {
                    discounts: get(merchantFeatures, 'discount.enabled', false)
                                || get(merchantFeatures, 'discounts.enabled', false),
                    shipping: get(merchantFeatures, 'shipping.enabled', false),
                    pinterest: get(merchantFeatures, 'pinterest.enabled', false),
                    facebookPixel: get(merchantFeatures, 'facebookPixel.enabled', false),
                    fullstory: get(merchantFeatures, 'fullstory.enabled', false),
                    googleAnalytics: get(merchantFeatures, 'googleAnalytics.enabled', false),
                    privy: get(merchantFeatures, 'privy.enabled', false),
                    mailchimp: get(merchantFeatures, 'mailchimp.enabled', false),
                    chat: get(merchantFeatures, 'chat.enabled', false),
                    zapier: get(merchantFeatures, 'zapier.enabled', false),
                    yotpo: get(merchantFeatures, 'yotpo.enabled', false),
                    amazon: get(merchantFeatures, 'amazon.enabled', false),
                    quickbooks: get(merchantFeatures, 'quickbooks.enabled', false),
                    xero: get(merchantFeatures, 'xero.enabled', false),
                    fulfillers: get(merchantFeatures, 'fulfillers.enabled', false),
                    avalara: get(merchantFeatures, 'avalara.enabled', false)
                };
            });
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/access/features/features.service.js